var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useStore } from "effector-react";
import { Typography, Box, TableContainer, Table, TableBody, Paper, useMediaQuery, useTheme, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DataTableLayout } from "frontend/src/ui/data-table-layout";
import { $hasAnyTimetables, $hasAnyWebSchedules, $isPageLoaded, $timetables, $webSchedules, pageMounted, pageUnmounted, } from "./model";
import { DesktopTimetableRow, MobileTimetableRow } from "./timetable-row";
import { EmployeeUserLayout } from "frontend/src/pages/layouts";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { TrackRow } from "frontend/src/ui/track-row";
import { TableCell, TableHead, TableRow } from "@material-ui/core";
import { $activeWebSchedule, playWebScheduleAttempted, stopWebScheduleAttempted, } from "frontend/src/features/play-web-schedule";
var useStyles = makeStyles(function (theme) { return ({
    glassPanel: {
        overflow: "hidden",
        color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
        backgroundColor: theme.palette.type === "dark"
            ? "rgba(15, 21, 31, 0.32)"
            : "rgba(255, 255, 255, 0.30)",
        backdropFilter: "blur(22px) saturate(145%)",
        WebkitBackdropFilter: "blur(22px) saturate(145%)",
        border: "1px solid rgba(255, 255, 255, 0.18)",
        borderRadius: 8,
        boxShadow: "0 20px 48px rgba(0, 0, 0, 0.16)",
    },
    empty: {
        color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
    },
}); });
var Timetables = function () {
    var classes = useStyles();
    var theme = useTheme();
    var timetables = useStore($timetables);
    var showMobileTable = useMediaQuery(theme.breakpoints.down("xs"));
    var TimetableRowComponent = showMobileTable
        ? MobileTimetableRow
        : DesktopTimetableRow;
    return (React.createElement(Box, { mt: 2 },
        React.createElement(TableContainer, { component: Paper, elevation: 0, className: classes.glassPanel },
            React.createElement(Table, null,
                React.createElement(TableBody, null, timetables.map(function (timetable) { return (React.createElement(TimetableRowComponent, __assign({ key: timetable.id }, timetable))); }))))));
};
var WebScheduleRow = function (_a) {
    var id = _a.id, title = _a.title;
    var classes = useStyles();
    var activeWebSchedule = useStore($activeWebSchedule);
    var isSelectedForPlayer = (activeWebSchedule === null || activeWebSchedule === void 0 ? void 0 : activeWebSchedule.id) === id;
    var play = function () { return playWebScheduleAttempted({ id: id, title: title }); };
    return (React.createElement(TrackRow, { isSelectedForPlayer: isSelectedForPlayer },
        React.createElement(TableCell, { className: classes.cell, width: "5%" },
            React.createElement(AudioControlButton, { isLoading: false, onPause: stopWebScheduleAttempted, onPlay: play, isPlaying: isSelectedForPlayer })),
        React.createElement(TableCell, { className: classes.cell },
            React.createElement(Typography, null, title))));
};
var WebSchedules = function () {
    var classes = useStyles();
    var schedules = useStore($webSchedules);
    var theme = useTheme();
    var showMobileTable = useMediaQuery(theme.breakpoints.down("xs"));
    return (React.createElement(Box, { mt: 2 },
        React.createElement(TableContainer, { component: Paper, elevation: 0, className: classes.glassPanel },
            React.createElement(Table, null,
                !showMobileTable && (React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { className: classes.cell }),
                        React.createElement(TableCell, { className: classes.cell }, "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435")))),
                React.createElement(TableBody, null, schedules.map(function (schedule) { return (React.createElement(WebScheduleRow, { key: schedule.id, id: schedule.id, title: schedule.title })); }))))));
};
var SchedulesBlock = function () {
    var classes = useStyles();
    var hasAnyWebSchedules = useStore($hasAnyWebSchedules);
    if (!hasAnyWebSchedules) {
        return (React.createElement(Box, { component: Paper, elevation: 0, p: 2, mt: 2, className: classes.glassPanel },
            React.createElement(Typography, { className: classes.empty }, "\u041F\u043E\u043A\u0430 \u0447\u0442\u043E \u0437\u0434\u0435\u0441\u044C \u043D\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F.")));
    }
    return React.createElement(WebSchedules, null);
};
var Page = function () {
    var classes = useStyles();
    var hasAnyTimetables = useStore($hasAnyTimetables);
    var table;
    if (hasAnyTimetables) {
        table = React.createElement(Timetables, null);
    }
    else {
        table = (React.createElement(Box, { component: Paper, elevation: 0, p: 2, className: classes.glassPanel },
            React.createElement(Typography, { className: classes.empty }, "\u041F\u043E\u043A\u0430 \u0447\u0442\u043E \u0437\u0434\u0435\u0441\u044C \u043D\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0439 \u0441\u0435\u0442\u043A\u0438 \u0432\u0435\u0449\u0430\u043D\u0438\u044F.")));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h6", style: { marginBottom: 8 } }, "\u0421\u0435\u0442\u043A\u0438 \u0432\u0435\u0449\u0430\u043D\u0438\u044F"),
        React.createElement(DataTableLayout, { table: table }),
        React.createElement(Typography, { variant: "h6", style: { marginTop: 24, marginBottom: 8 } }, "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F"),
        React.createElement(SchedulesBlock, null)));
};
export var TimetablesPage = function () {
    var isLoaded = useStore($isPageLoaded);
    React.useEffect(function () {
        pageMounted();
        return pageUnmounted;
    }, []);
    return React.createElement(EmployeeUserLayout, null, isLoaded ? React.createElement(Page, null) : null);
};
